import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../utils/scroll';
const rows = [{
  n: '1/4',
  title: 'Planificación',
  before: 'Noches de domingo buscando ejercicios en YouTube que no terminan de encajar.',
  after: '−90% tiempo. Sesiones listas en tu móvil en solo 2 clics.'
}, {
  n: '2/4',
  title: 'Seguridad',
  before: 'Inseguridad al entrenar grupos con niveles mezclados o jugadores que no progresan.',
  after: 'Confianza total. Progresiones claras, pedagógicas y medibles semana a semana.'
}, {
  n: '3/4',
  title: 'Variedad',
  before: 'Los mismos 10 ejercicios de siempre que tus jugadores ya conocen de memoria.',
  after: '+100% originalidad. Ejercicios dinámicos con consignas que motivan y desafían.'
}, {
  n: '4/4',
  title: 'Energía',
  before: 'Llegas al pabellón mentalmente cansado de haber organizado todo desde cero.',
  after: 'Cero estrés. Llegas con energía para conectar con tus jugadores desde el primer minuto.'
}];
const footerStats = [{
  value: '+120h',
  label: 'Ahorradas al año'
}, {
  value: '2 clics',
  label: 'Para cada sesión lista'
}, {
  value: '100%',
  label: 'Profesional'
}];
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-231" data-mp="mgdmg9pcac5x">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-232" data-mp="rh1mtlzgk5ct">
        <SectionTag icon="⚡" data-id="element-233" data-mp="dh09h720b5gg">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-234" data-mp="dil4exs8gqeu">
          Tus domingos no deberían terminar así...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-235" data-mp="27urtn0hyp7q5">
          Un domingo por la noche, buscando ejercicios sueltos que no sabes si van a funcionar el lunes.
        </p>

        <div className="mt-6 rounded-2xl border border-orange/20 bg-orange/5 p-5 text-left sm:p-6" data-id="element-236" data-mp="3kttn98125g1m">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-orange" data-id="element-237" data-mp="3fu798wdenvrr">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-238" data-mp="3bt55c28jmvjg">
            <span className="font-semibold text-white" data-id="element-239" data-mp="36v3mnif14y8i">El coste real:</span> Planificar manualmente te
            quita de 3 a 5 horas por semana. Es el equivalente a un mes entero de trabajo al año quemado en
            YouTube, cuadernos y dudas mentales.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-240" data-mp="3uqg4zny37qzf">
        <div className="space-y-4" data-id="element-241" data-mp="3pswk456vwfyi">
          {rows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-white/10 bg-bg-secondary p-5 sm:p-6" data-id="element-242" data-mp="3pqtsjgq32ero" data-mpi={i}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-243" data-mp="yn8bkhfel0le">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-244" data-mp="13nmlk50kekm2">
                <div className="flex items-start gap-3" data-id="element-245" data-mp="17nmzlojr4tsl">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-danger/15" data-id="element-246" data-mp="1cm7z1lr6j9fz">
                    <XIcon size={14} className="text-danger" data-id="element-247" data-mp="1hk9l8fjwjovo" />
                  </div>
                  <div data-id="element-248" data-mp="1mb82bhcpsqzz">
                    <p className="text-xs font-semibold uppercase tracking-wide text-danger" data-id="element-249" data-mp="1md2mgtg5wf30">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-250" data-mp="1r9jbrqz3kzho">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-251" data-mp="1valbsa0u9fkp">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/15" data-id="element-252" data-mp="20ckd7ed0q2f0">
                    <CheckIcon size={14} className="text-success" data-id="element-253" data-mp="1mmzaoj11vy7e" />
                  </div>
                  <div data-id="element-254" data-mp="1imp0eu686lmq">
                    <p className="text-xs font-semibold uppercase tracking-wide text-success" data-id="element-255" data-mp="1ildykzwcbny9">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-white" data-id="element-256" data-mp="1wgg59p90hhc4">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-257" data-mp="13rr821b2tw5n">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-258" data-mp="zpnwlcoeqrkd">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-259" data-mp="1dpf733fptptm">
          <ScrollHintTable minWidth="480px" data-id="element-260" data-mp="18p0wpeqn63sf">
            <div className="grid grid-cols-3 divide-x divide-white/10" data-id="element-261" data-mp="18o9ct16epuhz">
              {footerStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-262" data-mp="2p1fyyr7vludl">
                  <span className="font-heading text-xl font-bold text-orange sm:text-2xl" data-id="element-263" data-mp="2k6ae7vq7mlr3">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-264" data-mp="5yrnt3ho4mf1">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}